import { NavegacionProductos } from '../../components';

const FrijolesRefritosNegros = () => {
    return <NavegacionProductos />;
};

export default FrijolesRefritosNegros;
